'use strict';

const asyncPool = require('tiny-async-pool');

const MIN_CHUNK_SIZE = 10 * 1000 * 1000; // 10MB
const MAX_CHUNK_SIZE = 100 * 1000 * 1000; // 100MB
const TARGET_CHUNK_COUNT = 20;
const MAX_RETRIES = 3;
const MAX_CONCURRENT = 3;

module.exports = async function (baseUrl, name, type, blob, queryStringObj, onProgress, onStart) {
	const startData = await $.ajax({
		url: baseUrl + '/start',
		type: 'POST',
		data: Object.assign({ name, type }, queryStringObj),
	});

	// /start is where the server mints its own record for this upload, so hand the response
	// back to the caller — otherwise it has to re-query afterwards and guess which row is its.
	onStart && onStart(startData);

	const chunkSize = Math.max(
		MIN_CHUNK_SIZE,
		Math.min(
			MAX_CHUNK_SIZE,
			Math.ceil(blob.size / TARGET_CHUNK_COUNT)
		)
	);
	const chunkCount = Math.ceil(blob.size/ chunkSize);
			
	let completed = 0;
	let partUploaders = [];
	
	for (let i = 0; i < chunkCount; i++) {
		const start = chunkSize * i;
		const end = (i < chunkCount - 1) ? chunkSize * (i + 1) : undefined;
		const partBlob = blob.slice(start, end);
		
		partUploaders.push(async () => {
			const urlData = await $.ajax({
				url: baseUrl + '/part',
				type: 'GET',
				data: Object.assign({ name: name, type: type, partNumber: i + 1, uploadId: startData.uploadId }, queryStringObj),
			});
	
			const partRequest = await ajaxRetry({
				url: urlData.url,
				type: 'PUT',
				data: partBlob,
				headers: {
					'Content-Length': partBlob.length,
				},
				contentType: false,
				processData: false,
			}, MAX_RETRIES);
								
			const etag = partRequest.request.getResponseHeader('etag');
			
			completed += 1;
			onProgress && onProgress(completed / chunkCount);

			return { ETag: etag, PartNumber: i + 1 };
		});
	}
		
	const parts = await asyncPool(MAX_CONCURRENT, partUploaders, uploader => uploader());
	
	const result = await $.ajax({
		url: baseUrl + '/complete',
		type: 'POST',
		dataType: 'json',
		contentType: 'application/json',
		data: JSON.stringify(Object.assign({ name: name, type: type, uploadId: startData.uploadId, parts }, queryStringObj)),
	});
	
	return 's3:///' + result.Key;
};

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

async function ajaxRetry(params, tries = 3) {
	try {
		const request = $.ajax(params);
		await request;
		return { request };
	} catch (e) {
		if (tries > 0) {
			console.log('trying again', tries);
			await delay((4 - tries) * 500); // 500, 1000, then 1500 ms
			return ajaxRetry(params, tries - 1);
		} else {
			console.log('too many tries')
			throw e;
		}
	}
};
